// Owner: integrations. The address of Settings › Connections › Apps (`?app=<id>&atab=<tab>&github=<result>`):
// one schema for the route and for the former Connections › Apps addresses that land there. A light module, so
// the routes check the address without loading the page.
import { z } from 'zod';

export const APP_TABS = ['overview', 'migration', 'linking', 'simulation', 'activity', 'settings'] as const;
export type AppTab = (typeof APP_TABS)[number];

export const AppsSearch = z.object({
  app: z.string().max(80).optional().catch(undefined),
  atab: z.enum(APP_TABS).optional().catch(undefined),
  /** The result of connecting GitHub (the OAuth callback lands here). */
  github: z.enum(['connected', 'denied', 'failed']).optional().catch(undefined),
});
export type AppsSearch = z.output<typeof AppsSearch>;
